<template>
  <div class="container-fluid">
    <div class="row justify-content-center body">
      <template v-if="errorMessage != ''">
        <div class="alert alert-danger top-label" role="alert">
          {{ errorMessage }}
        </div>
      </template>
      <template v-if="successMessage != ''">
        <div class="alert alert-success top-label" role="alert">
          {{ successMessage }}
        </div>
      </template>
      <div class="col-12 col-sm-10 col-lg-7 main-body">
        <div class="py-3 text-center">
          <h3>{{ $t("reserveCancel.title") }}</h3>
        </div>

        <div class="text-center">
          <!-- テーブル -->
          <div class="sticky_table_wrapper border rounded table-responsive" style="height: 25em; white-space: nowrap;">
            <table class="table sticky_table">
              <thead class="sticky-top">
                <tr class="bg-info text-light">
                  <th>キャンセル</th>
                  <th>予約日</th>
                  <th>プラン名</th>
                  <th>人数</th>
                  <th>開始時間</th>
                  <th>終了時間</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in tableRecords" :key="index">
                  <td>
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :id="'reserve' + index"
                      :value="item"
                      v-model="selectedRecords"
                    />
                  </td>
                  <td>{{ dayCast(item.reservation_date) }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.people_num }}名</td>
                  <td>{{ timeCast(item.start_time) }}</td>
                  <td>{{ timeCast(item.end_time) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <form class="border bg-light p-3" @submit.prevent="submit" novalidate>
        <div class="row">
          <div class="d-grid gap-2 p-2 d-flex justify-content-center">
            <button
              type="submit"
              class="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
              :disabled="isButtonDisabled"
            >
              {{ $t("reserveCancel.cancelSubmit") }}
            </button>
          </div>
          </div>
        </form>
      </div>
    </div>

    <!-- モーダルの設定 -->
    <div
      class="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="text-danger modal-title" id="staticBackdropLabel">
              {{ $t("reserveCancel.warning") }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="閉じる"
            ></button>
          </div>
          <div class="modal-body">
            {{ $t("reserveCancel.warningText") }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              {{ $t("reserveCancel.false") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="cancel()"
            >
              {{ $t("reserveCancel.true") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reserveMixin from '@/mixins/reserveMixin.js'
import authMixin from '@/mixins/authMixin.js'
import Const from '../const'
import axios from 'axios'

export default {
  data() {
    return {
      tableRecords: [],
      selectedRecords: [],
      errorMessage: '',
      successMessage: '',
    };
  },
  methods: {
    cancel() {
      this.errorMessage  = '';
      this.successMessage  = '';
      var params = {
        'reservation_records': this.selectedRecords,
        'user_name' : this.$store.getters.personalName
      };
      axios.post(Const.BASE_URL + "/cancel", params,{
          headers: {
                "Authorization": this.$store.getters.token,
                "Content-Type": "application/json"
          }
        }
      ).then(() => {
          this.successMessage = 'キャンセルしました。';
        // 再描写
        this.getRecord();
        this.selectedRecords = [];
      }).catch(function(error) {
        // console.log(error);
        if ("404" == error.response.status) {
          // キャンセルエラー
          this.errorMessage = '既にキャンセル済みです。';
          // 再描写
          this.getRecord();
          this.selectedRecords = [];
        } else {
          // その他エラー
          this.errorMessage = 'エラーが発生しました。';
        }
      }.bind(this));
      this.returnWindowTop()
    },
    async getRecord() {
      axios.get(Const.BASE_URL + "/user-reservation", {
        headers: {
          "Authorization": this.$store.getters.token,
          "Content-Type": "application/json"
        },
        params: { 'email_address': this.email }

      }).then((res) => {
        // console.log(res)
        this.tableRecords = res.data.reservations;
      });
    },
    dayCast: function(day) {
      //yyyy-mm-dd
      return day.slice(0, 4) + '-' + day.slice(4, 6) + '-' + day.slice(6);
    },
    timeCast: function(time) {
      //hh:mm
      return time.slice(0, 2) + ':' + time.slice(2);
    },
    returnWindowTop(){
      window.scrollTo({
        top: 0,
        behavior: "instant"
      });
    }
  },
  computed: {
    // 未選択の場合はキャンセルボタンが不活性
    isButtonDisabled: function() {
      if (this.selectedRecords.length == 0) return true;
      return false;
    }
  },
  async mounted() {
    this.getRecord();
  },
  mixins: [reserveMixin, authMixin],
};
</script>

<style scoped>
.body {
  padding-top: 70px;
}
.main-body {
  padding-top: 20px;
}
</style>
